// Components
const ModalAddEditDeleteDocument = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-notification-body" */ '@/app/views/main-view/general-info/modals/modal-add-edit-delete-document/modal-add-edit-delete-document.vue');
const ModalPetWeight = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-pet-weight" */ '@/app/views/main-view/general-info/modals/modal-pet-weight/modal-pet-weight.vue');
const ModalAddEditPetWeight = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-pet-weight" */ '@/app/views/main-view/general-info/modals/modal-add-edit-pet-weight/modal-add-edit-pet-weight.vue');
const ModalViewDocument = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-view-document" */ '@/app/views/main-view/general-info/modals/modal-view-document/modal-view-document.vue');

// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { switchPetMixins } from '@/app/mixins/modules/switch-pet-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

// Services
import documentService from '@/app/services/main/document/document-service.js';
import PetsService from '@/app/services/main/pets/pets-service';

// Third party libraries
import { format } from 'date-fns';
import DatePicker from 'vue2-datepicker';

export default {
    name: 'DocumentTableComponent',
    components: {
        DatePicker,
        ModalAddEditDeleteDocument,
        ModalPetWeight,
        ModalAddEditPetWeight,
        ModalViewDocument,
    },
    mixins: [
        GoogleAnalyticsMixins,
        toastMessageMixins,
        userMixins,
        tableMixins,
        switchPetMixins,
        dateMixins
    ],
    data() {
        return {
            // loaders
            isAPILoading: false,
            isAddModalLoading: false,
            // table
            theads: [
                { name: 'Description', sortLabel: 'description', isDesc: false, style: 'min-width: 20%;', hasSearch: true, searchLabel: 'f_description'},
                { name: 'Type', sortLabel: 'type', isDesc: false, style: 'min-width: 20%;', hasType: true, searchLabel: 'f_type'},
                { name: 'Name', sortLabel: 'name', isDesc: false, style: 'min-width: 15%;', hasSearch: true, searchLabel: 'f_name'},
                { name: 'Date', sortLabel: 'createdAt', isDesc: true, style: 'min-width: 20%;', hasScheduleSearch: true, searchLabel: 'f_createdAt'},
                { name: null, sortLabel: null, style: 'width: 5%;'},
                { name: null, sortLabel: null, style: 'width: 3%;'},
                { name: null, sortLabel: null, style: 'width: 3%;'}
            ],
            // sorting
            desc: true,
            // modal
            modalContent: null,
            frequencyList: [
                { name: 'png', code: 'png' },
                { name: 'jpeg', code: 'jpeg' },
                { name: 'jpg', code: 'jpg' },
                { name: 'svg', code: 'svg' },
                { name: 'gif', code: 'gif' },
                { name: 'raw', code: 'raw'  },
                { name: 'doc', code: 'doc' },
                { name: 'pdf', code: 'pdf' },
                { name: 'excel', code: 'excel' },
                { name: 'csv', code: 'csv' },
                { name: 'ppt', code: 'ppt' },
                { name: 'txt', code: 'txt'  },
                { name: 'html', code: 'html' },
                { name: 'zip', code: 'zip' },
                { name: 'rar', code: 'rar' },
            ],
            statusList: [
                { name: 'Active', code: 'A', value: 'ACTIVE'},
                { name: 'Inactive', code: 'I', value: 'INACTIVE' }
            ],
            selectedStatus: 'ACTIVE',
            dateRange: null,
            microchip: null,
            weight: "35.00 kg - 10 May 2021",
            editMicrochip: false,
            // Michrochip input field
            maxLength: 50,

            selectedDocumentId: null,
            documentsList: [],
        }
    },
    created() {
        this.columnsFilter['f_status'] = this.selectedStatus;
        this.getTableContent(this.page, this.limit, this.sortBy, this.desc = true);
        this.microchip = this.getActivePet.microchip ? this.getActivePet.microchip : '';
    },
    watch: {
        editMicrochip(newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.$refs.inputMichrochip.focus();
                }, 300);
            } else {
                this.microchip = this.getActivePet.microchip
            }
        },
        'getActivePet': {
            immediate: true,
            handler(newVal) {
                this.microchip = newVal.microchip;
            },
            deep: true
        }
    },
    computed: {
        isValidMichrochip() {
            return this.microchip !== this.getActivePet.microchip;
        },
    },
    methods: {
        isSelectedDocumentLoading(documentId){
            return this.selectedDocumentId === documentId;
        },
        setDocumentsList(actionType, selectedDocument){
            // this method is here needed for when the document's description is edited
            // so that we will still have the latest documents list
            
            if(actionType === "Edit"){
                this.documentsList = [...this.documentsList].map(docu => {
                    if(docu.id === selectedDocument.id){
                        return selectedDocument;
                    }

                    return docu;
                })
            }

            if(actionType === "Delete"){
                this.documentsList = [...this.documentsList].filter(docu => {
                    return docu.id !== selectedDocument.id;
                })
            }

        },
        refreshActivePetData() {
            this.columnsFilter['f_status'] = this.selectedStatus;
            this.getTableContent(this.page, this.limit, this.sortBy, this.desc = true);
            this.editMicrochip = false;
        },
        getTableContent(page = this.page, limit = this.isDashboard ? 5 : this.limit, sortBy = this.sortBy, desc = this.desc) {
            this.getReminderList({ page, limit, sortBy, desc });
        },
        getReminderList(queryParams) {

            queryParams['f_petId'] = this.getActivePet.id;
            if (this.columnsFilter['f_type']) {
                queryParams['f_type'] = this.columnsFilter['f_type'];
            }
            if (this.columnsFilter['f_note']) {
                queryParams['f_note'] = this.columnsFilter['f_note'];
            }
            if (this.columnsFilter['f_name']) {
                queryParams['f_name'] = this.columnsFilter['f_name'];
            }
            if (this.columnsFilter['f_description']) {
                queryParams['f_description'] = this.columnsFilter['f_description'];
            }
            if (this.columnsFilter['f_createdAt'] && this.columnsFilter['f_createdAt'][0]) {
                queryParams['f_startDate'] = format(new Date(this.columnsFilter['f_createdAt'][0]), 'yyyy-MM-dd');
                queryParams['f_endDate'] = format(new Date(this.columnsFilter['f_createdAt'][1]), 'yyyy-MM-dd');
            }

            this.isAPILoading = true;
        
            documentService.getDocumentLists(queryParams)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: res.data.data,
                            paginationData: res.data.pagination
                        };

                        this.isAPILoading = false;
                    } else {
                        this.isAPILoading = false;
                        const { ERROR_GET_DOCUMENTS } = this.toastMessages.document();
                        this.showAPIErrorToast(ERROR_GET_DOCUMENTS, res);
                    }
                });

        },
        refreshTableContent() {
            this.getTableContent(this.page, this.limit, null, true);
        },
        displayDate(date) {
            return this.formatDate(date);
        },
        displayFrequency(code) {
            return this.frequencyList.find(frequency => frequency.code === code).name;
        },
        displayStatus(s) {
            return this.statusList.find(status => status.code === s).name;
        },
        async previewDocument(document){
            const { documentUrl, type } = document;

            const imageTypes = ["png", "jpeg", "jpg", "gif", "svg+xml", "svg"];
            
            if(imageTypes.includes(type) || type === "pdf"){
                this.$refs.modalViewDocument.show(document);
            } else{
                window.open(documentUrl, '_blank')
            }
        },
        async showEditDocument(content) {
            this.$refs.modalAddEditDeleteDocument.show(content, "Edit");
        },
        async showDeleteDocument(content) {
            this.$refs.modalAddEditDeleteDocument.show(content, "Delete");
        },
        showPetWeightModal() {
            this.$refs.modalPetWeight.openModal();
        },
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked (event) {
            const files = event.target.files
            this.$refs.modalAddEditDeleteDocument.show(files[0],"Upload");
        },
        clearFileInput(event) {
            event.target.value = "";
        },
        blurMichrochip() {
            setTimeout(() => {
                if (this.editMicrochip) {
                    this.toggleEditMichrochip();
                }
            }, 300);
        },
        toggleEditMichrochip() {
            this.editMicrochip = !this.editMicrochip;
        },
        saveMicrochipAction(){
            if (!this.isValidMichrochip) {
                return;
            }
            const { SUCCESS_SAVE_MICROCHIP, SUCCESS_DELETE_MICROCHIP } = this.toastMessages.document(); 
            if (this.editMicrochip) {
                if (this.microchip.length !== 0) {
                    let microchipCode = {
                        "microchip": this.microchip
                    }

                    PetsService.putUpdateMicrochip(microchipCode, this.getActivePet.id)
                        .then( res => {
                            this.isAPILoading = false;
                            if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                                this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_SAVE_MICROCHIP);
                                this.getUserDetailsAPI(true, this.getActivePet.id);
                            } else {
                                this.showAPIErrorToast(null, res);
                            }
                        });
                } else {
                    if (this.getActivePet.microchip) {
                        
                        PetsService.deleteMicrochip(this.getActivePet.id)
                            .then(async response => {
                                if (response.status === 204) {
                                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_DELETE_MICROCHIP);
                                    this.getUserDetailsAPI(true, this.getActivePet.id);
                                } else {
                                    this.showAPIErrorToast(null, res);
                                }
                            });
                    }
                }
                this.toggleEditMichrochip();
            }
        },
        addEditPetWeight(modalContent) {
            this.$refs.modalAddEditPetWeight.show(modalContent);
            this.$refs.modalPetWeight.closeModal();
        },
        closeAddEditPetWeight() {
            if(this.$refs.modalPetWeight) {
                this.$refs.modalPetWeight.openModal();
            }
        },
        isLetterAndNum(event){
            let char = String.fromCharCode(event.keyCode);
            if (/^[A-Za-z0-9]+$/.test(char)) {
                return true;
            } else {
                event.preventDefault();
            }
        },
    }
}